import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0B5CD2",
      "fill-rule": "evenodd",
      d: "M18.997 8.974H19a1 1 0 0 1 1 .997 9.93 9.93 0 0 1-2.909 7.08 9.94 9.94 0 0 1-7.062 2.95H10a9.93 9.93 0 0 1-7.051-2.91A9.94 9.94 0 0 1 0 10.03a9.93 9.93 0 0 1 2.909-7.08A9.94 9.94 0 0 1 9.971 0c.795.012 1.605.092 2.381.278a1 1 0 0 1-.469 1.945A8.8 8.8 0 0 0 9.977 2a7.95 7.95 0 0 0-5.65 2.36A7.95 7.95 0 0 0 2 10.022a7.95 7.95 0 0 0 2.359 5.65A7.95 7.95 0 0 0 10 18h.023a7.95 7.95 0 0 0 5.65-2.359A7.95 7.95 0 0 0 18 9.977a1 1 0 0 1 .997-1.003m-12.704.319a1 1 0 0 1 1.414 0l2.244 2.244 6.297-7.196a1 1 0 0 1 1.504 1.318l-7 8a1 1 0 0 1-.719.341H10a1 1 0 0 1-.707-.293l-3-3a1 1 0 0 1 0-1.414",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }